import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import axios from "axios";

const TotalValue = ({ showRuneBal }: { showRuneBal?: any }) => {
  const [totalValue, setTotalValue] = useState<any>(0);
  const [totalBalance, setTotalBalance] = useState<any>(0);
  const [priceData, setPriceData] = useState<any>([]);
  function filterArray(
    firstArray: any,
    secondArray: any,
    firstKey: any,
    secondKey: any
  ) {
    // Create a set of matching values from the second array
    const secondSet = new Set(secondArray.map((item: any) => item[secondKey]));

    // Filter the first array based on the matching values
    const filteredFirstArray = firstArray.filter((item: any) =>
      secondSet.has(item[firstKey])
    );

    return filteredFirstArray;
  }

  const getAllData = (
    collectionName: string,
    callback: (data: any[] | undefined) => void
  ) => {
    const collectionRef = collection(db, collectionName);

    const unsubscribe = onSnapshot(
      collectionRef,
      (querySnapshot) => {
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs.map((doc) => doc.data());
          callback(data);
        } else {
          console.log("No documents found!");
          callback(undefined);
        }
      },
      (error) => {
        console.error("Error getting real-time updates: ", error);
        callback(undefined);
      }
    );

    return unsubscribe;
  };

  function getAllStackedItems(dataArray: any) {
    let allStackedItems: any = [];

    dataArray?.forEach((item: any) => {
      if (item.stalkedItems && Array.isArray(item.stalkedItems)) {
        allStackedItems = allStackedItems.concat(item.stalkedItems);
      }
    });

    return allStackedItems;
  }

  function sumFpValues(dataArray: any) {
    return dataArray.reduce((acc: any, item: any) => {
      return acc + (item.fp || 0);
    }, 0);
  }

  function sumBalance(dataArray: any) {
    return dataArray.reduce((acc: any, item: any) => {
      return acc + (parseInt(item.balance) || 0);
    }, 0);
  }

  useEffect(() => {
    axios
      .get(
        // `https://api-mainnet.magiceden.dev/collection_stats/search/bitcoin?window=1d&sort=volume&direction=desc&offset=0&limit=100`
        `https://api.allorigins.win/raw?url=${encodeURIComponent(
          "https://api-mainnet.magiceden.dev/collection_stats/search/bitcoin?window=1d&sort=volume&direction=desc&offset=0&limit=100"
        )}`
      )
      .then((res) => setPriceData(res?.data))
      .catch((err) => console.log("err", err));
  }, []);

  useEffect(() => {
    if (priceData?.length !== 0) {
      const unsubscribe = getAllData("stalks", (newData) => {
        const data = getAllStackedItems(newData);

        let filtered = filterArray(
          priceData,
          data,
          "collectionSymbol",
          "symbol"
        );

        let formattedData = data.map((v: any) => ({
          ...v,
          fp: priceData?.find((item: any) => item?.collectionSymbol === v?.slug)
            ?.fp,
        }));

        let totalFp = sumFpValues(formattedData);

        setTotalValue(totalFp);

        // setTotalStalked(newData?.stalkedItems.length);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    }
  }, [priceData]);

  useEffect(() => {
    const unsubscribe = getAllData("Ruins", (newData) => {
      const data = getAllStackedItems(newData);
      const totalBalance = sumBalance(data);

      setTotalBalance(totalBalance);

      console.log("Ruins", data, totalBalance);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <>
      {showRuneBal ? (
        <span>{totalBalance}</span>
      ) : (
        <div className="flex-1">
          <div className="h-full bg-gradient-to-r from-body to-gray-800 border-2 border-primary rounded-lg shadow-lg p-6 relative">
            <div className="relative z-10">
              <h6 className="mb-1 font-semibold text-color">Total Value</h6>
              <h2
                title={totalValue}
                className="text-white font-bold text-3xl flex gap-1"
              >
                {/* {Math.floor(totalBalance + totalValue)} BTC */}
                <span className="truncate">{totalValue}</span>
                <span>BTC</span>
              </h2>
            </div>
            <img
              className="absolute bottom-0 right-0 h-28 w-28 opacity-20"
              src="/assets/images/icon-3.png"
              alt="..."
            />
          </div>
        </div>
      )}
    </>
  );
};
export default TotalValue;
